import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { LaboratoryViewControllerDelegate, LaboratoryViewController } from "../../Screen/Laboratory/LaboratoryViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { LaboratoryViewModel } from '../../Screen/Laboratory/LaboratoryViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class LaboratoryCoordinator implements IndexCoordinatorDelegate, LaboratoryViewControllerDelegate, TableGenericViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geplaboratorio")
        return (<ProtectedRoute requiredPermissions={['dengue.laboratorio.*']} path="/:base/dengue/laboratorio" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'dengue.laboratorio.adicionar',
                    edit: 'dengue.laboratorio.editar',
                    delete: 'dengue.laboratorio.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Laboratório"}
            />)
        }} />)
    }

    private routeForm(): JSX.Element {
        var viewModel = new LaboratoryViewModel()
        return (<ProtectedRoute requiredPermissions={['dengue.laboratorio.adicionar', 'dengue.laboratorio.editar']} path="/:base/dengue/laboratorio/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<LaboratoryViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "geplaboratorio") {
            navigation.history.push(`laboratorio/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "geplaboratorio") {
            navigation.history.push(`laboratorio/cad/${idSelection}`);
            return;
        }
    }

}